import { useContext, useMemo } from 'react'
import { db } from '../../firebase/config'
import { useFirestore } from '../../firebase/useFirestore'
import { SavedIcon } from '../../StateManagment/SavedIcon'

/**
 * Waarmee meet dit programma zijn leden?
 *
 * Eén keuze op de koepel: het onderzoek waarvan de vragenlijst bij álle
 * deelnemende organisaties hoort. Dat veld doet twee dingen tegelijk — het zegt
 * DAT deze omgeving een programma is, en WELKE vragenlijst op de deelname-rij
 * van elk huishouden komt.
 *
 * WAAROM EEN EXPLICIETE KEUZE EN GEEN AFLEIDING. Drie afleidingen zijn op
 * 2026-09-10 in productie nagemeten en alle drie afgevallen: `IsNetwork` klopte
 * alleen omdat één script het zo schreef (geen scherm zet dat veld), `Portfolio`
 * zou 22 andere koepels rijen geven, en 'portfolio mét een eigen onderzoek' 9
 * koepels met samen 40 leden. Een instelling die een mens aanzet is hier beter:
 * de afwezigheid ervan is uit te leggen in plaats van stil.
 *
 * Een keuzelijst en geen vinkje — dan kan er ook geen tekst-`'true'` in sluipen.
 * AI-CONTEXT: See docs/pitfalls.md#ui-togglebutton-string-only-branches
 * AI-CONTEXT: See docs/features/energiearmoede-arnhem-ketensamenwerking.md
 */
const SharedResearchSelect = () => {
    // Context
    const [, setSaved] = useContext(SavedIcon)

    // Firestore
    const compagny = useFirestore('CompagnyMeta')
    const research = useFirestore('Research')

    const meta = Array.isArray(compagny) ? compagny[0] : null

    const onderzoeken = useMemo(
        () => (Array.isArray(research) ? research : []),
        [research]
    )

    // 'Nog niet bekend' is iets anders dan 'leeg'. Zolang de lijst onderweg is
    // beweren we niets — een tekst 'dit programma heeft nog geen onderzoek' is
    // een bewering aan de lezer, en die zou dan onwaar zijn.
    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    const onderzoekenGeladen = Array.isArray(research)

    const changeHandler = async (e) => {
        // Waarde EERST uitlezen: `e.target` is het levende element en heeft bij
        // een controlled select de oude waarde alweer terug tegen de tijd dat
        // een async vervolg hem leest.
        // AI-CONTEXT: See docs/pitfalls.md#state-updater-reads-event-target-too-late
        const value = e.target.value

        if (!meta?.docid) return

        await db.collection('CompagnyMeta').doc(meta.docid).update({
            SharedResearchID: value,
        })

        setSaved('flex')
    }

    if (!meta?.docid) return null

    return (
        <div className='shared-research-select'>
            <h3>Meten via dit programma</h3>
            <p className='shared-research-select-explainer'>
                Kies het onderzoek waarmee dit programma zijn deelnemende organisaties meet.
                De deelnemers krijgen die vragenlijst bij hun huishoudens te zien, ook al staat
                het onderzoek hier.
            </p>

            {!onderzoekenGeladen ? null : onderzoeken.length === 0 ? (
                <p className='shared-research-select-empty'>
                    Dit programma heeft nog geen onderzoek. Maak er eerst een aan onder
                    <strong> 'Meten'</strong>, met de meetmomenten erbij.
                </p>
            ) : (
                <label className='shared-research-select-field'>
                    <span>Onderzoek</span>
                    <select value={meta.SharedResearchID || ''} onChange={changeHandler}>
                        <option value=''>-- Niet meten via dit programma --</option>
                        {onderzoeken.map((item) => (
                            <option key={item.ID} value={item.ID}>{item.Title}</option>
                        ))}
                    </select>
                </label>
            )}
        </div>
    )
}

export default SharedResearchSelect
